/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  'goal-actions.archive-goal.generic-error-title': 'Не удалось заархивировать цель',
  'goal-actions.copy-goal.cancel': 'Отмена',
  'goal-actions.copy-goal.close-modal': 'Закрыть окно',
  'goal-actions.copy-goal.error': 'Дайте цели название, чтобы все понимали, о чем идет речь',
  'goal-actions.copy-goal.failed-description': 'При клонировании цели произошла ошибка. Повторите попытку позже.',
  'goal-actions.copy-goal.failed-description-forbidden': 'У вас нет права на копирование этой цели.',
  'goal-actions.copy-goal.failed-title': 'Не удалось клонировать цель.',
  'goal-actions.copy-goal.followers': 'Подписчики',
  'goal-actions.copy-goal.goal-name': 'Название цели',
  'goal-actions.copy-goal.include': 'Включить',
  'goal-actions.copy-goal.links': 'Ссылки',
  'goal-actions.copy-goal.submit': 'Отправить',
  'goal-actions.copy-goal.success-description': 'Цель клонирована.',
  'goal-actions.copy-goal.success-link': 'Просмотреть клонированную цель.',
  'goal-actions.copy-goal.success-title': 'Цель «{goalName}» клонирована.',
  'goal-actions.copy-goal.title': 'Копировать цель',
  'goal-actions.follow-goal.follow-error-title': 'Не удалось подписаться на цель',
  'goal-actions.follow-goal.unfollow-error-title': 'Не удалось отписаться от цели',
  'goal-actions.goal-actions.archive-error-title': 'цель не удалось восстановить',
  'goal-actions.goal-actions.archive-goal': 'Архивировать цель',
  'goal-actions.goal-actions.archive-restore-error-description':
    'изменения цели не удалось сохранить. Повторите попытку позже.',
  'goal-actions.goal-actions.copy-goal': 'Копировать цель',
  'goal-actions.goal-actions.copy-link': 'Копировать ссылку',
  'goal-actions.goal-actions.follow': 'Отслеживать',
  'goal-actions.goal-actions.generic-error-description': 'Произошла ошибка. Повторите попытку через несколько минут.',
  'goal-actions.goal-actions.restore-goal': 'Восстановить цель',
  'goal-actions.goal-actions.share': 'Поделиться',
  'goal-actions.goal-actions.show-more': 'Показать еще',
  'goal-actions.goal-actions.unfollow': 'Отписаться',
  'goal-actions.goal-content.follow-confirmation-description':
    'В первую неделю следующего месяца вы получите дайджест с обновлениями по всем целям, которые отслеживаете.',
  'goal-actions.goal-content.follow-confirmation-title': '🙌🏼 Теперь вы отслеживаете эту цель!',
  'goal-actions.restore-goal.generic-error-title': 'Не удалось восстановить цель',
};
